export default "__VITE_ASSET__s6Pn83ok__"